class Cart {
    constructor(id = null) {
        this.services = [];
        this.servicesIds = [];

        this.totalServicesPrice = 0;
        this.servicesInCart = 0;

        this.loaded = false;
        this.orderId = '';

        this.fillDefaultOrder(id);
    }


    //вывод в корзину общей суммы заказа
    getTotalServicesPrice() {
        return parseFloat(this.totalServicesPrice).toFixed(0);
    }

    //показывает кол-во продуктов в корзине
    getServicesInCart() {
        return this.servicesInCart;
    }

    //выполняется запрос для получения данных о продуктах, которые уже в корзине
    fillDefaultOrder(id) {
        axios.post('/cart/get', {id: id}).then(res => {
            this.orderId = res.data.id;
            this.services = res.data.items;
            this.servicesIds = res.data.items.map(item => item.cartService.id);
            this.updateCalculations();
            this.loaded = true;
        });
    }

    //добавление товара в корзину
    addToCart(data, price_with_discount) {
        if (this.servicesIds.indexOf(data.id) < 0) {

            this.services.push({
                service: data,
                cartService: {
                    id: data.id,
                    price: data.price,
                    code: data.code,
                    special_points: data.special_points,
                    with_discount: price_with_discount ? price_with_discount : 0,
                }
            });
            this.servicesIds.push(data);
        }

        this.updateCalculations();
        this.storeOrderItemsChange();
        this.showModal(data.special_points);
    }

    //подсчет общей суммы заказа через перемножение кол-ва и цены в каждом товаре
    calculateTotalServicesPrice() {
        let price = 0;
        let checkDiscount;
        let sum;
        this.services.forEach(function (service) {
            checkDiscount = service.cartService.with_discount !== 0 ? service.cartService.with_discount : service.cartService.price;
            sum = Number(checkDiscount);
            price += parseFloat(sum);
        });
        this.totalServicesPrice = parseFloat(price).toFixed(2);
    }

    //подсчет кол-ва продуктов в корзине
    calculateServicesInCart() {
        let count = 0;
        this.services.forEach(function () {
            count += 1;
        });

        this.servicesInCart = count;
    }

    //обновление данных
    updateCalculations() {
        this.calculateTotalServicesPrice();
        this.calculateServicesInCart();
    }


    //Изменение данных продукта в корзине
    storeOrderItemsChange() {
        axios.post('/cart/' + this.orderId + '/store-order-services-change', {
            services: this.services
        });
    }

    //показывает корзину
    showModal(special_points) {
        window.modal.type = 'cart_modal';
        window.modal.special_points = special_points;
        $('#main-modal').modal('show');
    }

}

export default Cart;


// WEBPACK FOOTER //
// ./resources/assets/js/core/Cart.js